import { render } from "./VAlert.vue?vue&type=template&id=3cba475a"
import script from "./VAlert.vue?vue&type=script&lang=js"
export * from "./VAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__